import { z } from "zod";

type Padding = Partial<{
    top: number;
    left: number;
    bottom: number;
    right: number;
    all: number;
    leftRight: number;
    topBottom: number;
    fillParentWidth?: boolean;
}>;

const paddingZodSchema: z.ZodSchema<Padding> = z
    .object({
        top: z.number(),
        left: z.number(),
        bottom: z.number(),
        right: z.number(),
        all: z.number(),
        leftRight: z.number(),
        topBottom: z.number(),
        fillParentWidth: z.boolean().optional(),
    })
    .partial();

export { paddingZodSchema };
export type { Padding };
